export const ACTION_TYPES = [
    "jab",
    "cross",
    "hook",
    "uppercut",
    "low_kick",
    "body_kick",
    "head_kick",
    "takedown",
    "knockdown",
    "submission",
    "control_time_start",
    "control_time_stop",
];
export const STRIKE_TYPES = [
    "jab",
    "cross",
    "hook",
    "uppercut",
    "low_kick",
    "body_kick",
    "head_kick",
];
export const PUNCH_TYPES = ["jab", "cross", "hook", "uppercut"];
export const KICK_TYPES = ["low_kick", "body_kick", "head_kick"];
export const OUTCOMES = ["landed", "missed", "attempted", "successful"];
// --- Grafik-controller: vMix-grafikkerne styret fra /admin/gfx ---
// Hvor på skærmen en grafik sidder. Går en grafik på, tages de andre i samme
// slot af — ligesom et overlay-kanal i vMix kun viser ét input ad gangen.
// `timer` er uret grafikken viser (startes når grafikken går på).
export const GFX_GRAPHICS = {
    ur: { slot: "bottom" },
    statsBlue: { slot: "bottom" },
    statsRed: { slot: "bottom" },
    decision: { slot: "bottom" },
    nextMatch: { slot: "bottom" },
    countdown: { slot: "bottom", timer: "countdown" },
    name: { slot: "bottom" },
    smallName: { slot: "bottom" },
    h2h: { slot: "bottom" },
    // Spotter-grafikkerne (stats fra spotterens registreringer).
    recap: { slot: "center" },
    breakdown: { slot: "center" },
    final: { slot: "center" },
    flash: { slot: "flash" },
};
// Standardlængde for urene i sekunder. Rundeuret bruger kampens rundelængde.
export const GFX_TIMERS = { round: 300, medical: 300, countdown: 600 };
//# sourceMappingURL=index.js.map